<template>
  <div class="cliente-main-apartado" v-if="arrayArticulos.length > 0">
    <div class="cliente-main-apartado-titulo">Recomendaciones</div>
    <div class="apartado-slider">
      <splide
        :options="options"
        :slides="arrayArticulos"
      >
        <splide-slide v-for="(articulo,index) in arrayArticulos" :key="index">
          <cliente-articulo :producto="articulo"/>
        </splide-slide>
      </splide>
    </div>
  </div>

</template>
<script>
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import ClienteArticulo from './ClienteArticulo.vue'
import { ClienteApiService } from '@/api/ClienteApiService';
const clienteApiService = new ClienteApiService()

export default {
  name: 'clienteRecomendados',
  components: {
    ClienteArticulo, Splide, SplideSlide
  },
  data() {
    return {
      options: {
        rewind: false,
        gap   : '2px',
        fixedWidth : '200px',
        arrows: true,
        pagination: false
     },
      arrayArticulos: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getRecomendadosByCliente()
    },
    getRecomendadosByCliente() {
      clienteApiService.getRecomendadosByCliente(this.$store.getters.getCliente.idTwister,10)
        .then(data => {
          this.arrayArticulos = data
          console.log(data)
        })
        .catch(error => {
          console.log (error)
        })
    }
  },
}
</script>